var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 18,
    height: 18,
    transform: "translate(60 171)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_34",
    "data-name": "Mask Group 34",
    transform: "translate(-60 -171)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(58.682 169.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M17.406,10.8V9.819l1.238-1.083a1.289,1.289,0,0,0,.245-1.644L17.368,4.513a1.3,1.3,0,0,0-1.528-.58l-1.567.529a7.317,7.317,0,0,0-.845-.484L13.1,2.353a1.289,1.289,0,0,0-1.289-1.038H8.793A1.289,1.289,0,0,0,7.5,2.353L7.175,3.978a7.4,7.4,0,0,0-.851.484L4.79,3.907a1.289,1.289,0,0,0-.413-.039,1.289,1.289,0,0,0-1.115.645L1.741,7.092A1.289,1.289,0,0,0,2,8.71L3.223,9.825v.986L2,11.894a1.289,1.289,0,0,0-.264,1.644l1.521,2.579a1.3,1.3,0,0,0,1.528.58l1.567-.529a7.317,7.317,0,0,0,.845.484l.329,1.625a1.289,1.289,0,0,0,1.289,1.038h3.043a1.289,1.289,0,0,0,1.289-1.038l.329-1.625a7.4,7.4,0,0,0,.851-.484l1.56.529a1.3,1.3,0,0,0,1.528-.58l1.47-2.579a1.289,1.289,0,0,0-.264-1.618Zm-1.154,4.667-2.211-.748a5.712,5.712,0,0,1-1.747,1.012l-.458,2.314H8.793l-.458-2.289A6.034,6.034,0,0,1,6.6,14.75l-2.218.722L2.856,12.894l1.754-1.547a5.738,5.738,0,0,1,0-2.018L2.856,7.736,4.377,5.157l2.211.748A5.712,5.712,0,0,1,8.336,4.893l.458-2.314h3.043l.458,2.289a6.034,6.034,0,0,1,1.741,1.012l2.218-.722,1.521,2.579L16.02,9.283a5.738,5.738,0,0,1,0,2.018l1.754,1.592Z",
    fill: "#9babc5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M10.315,14.183a3.868,3.868,0,1,1,3.868-3.868,3.829,3.829,0,0,1-3.868,3.868Zm0-6.447a2.521,2.521,0,0,0-2.579,2.579,2.521,2.521,0,0,0,2.579,2.579,2.521,2.521,0,0,0,2.579-2.579,2.521,2.521,0,0,0-2.579-2.579Z",
    fill: "#9babc5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.0e337c97cda98d2653b5851d04751a4c.svg";
export { ForwardRef as ReactComponent };